// ADDED
import React, { useState } from "react";
import SalaryAdvanceAccessTable from "./components/SalaryAdvanceAccessTable";
import SalaryAdvanceAccessAddEditModal from "./components/SalaryAdvanceAccessAddEditModal";
import { SearchBar } from "../../../../common/APICommon";

const SalaryAdvanceAccessModule = ({
  user,
  data,
  searchData,
  updateAccess
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleSearch = (value) => {
    setCurrentPage(1);
    searchData(value);
  };

  const handleSave = async (accessType) => {
    if (!selectedItem) return;

    // Convert string accessType back to payload fields
    const payload = {
      isSalaryAdvanceAssignmentManager: accessType === "assignment",
      isSalaryAdvanceReleasingManager: accessType === "releasing"
    };

    // Prepare Audit Trail
    const auditEntries = [];
    const fieldsToTrack = [
      { key: "isSalaryAdvanceAssignmentManager", label: "Assignment Manager" },
      { key: "isSalaryAdvanceReleasingManager", label: "Releasing Manager" }
    ];

    fieldsToTrack.forEach(field => {
      const oldValue = !!selectedItem[field.key] ? "Yes" : "No";
      const newValue = payload[field.key] ? "Yes" : "No";

      if (oldValue !== newValue) {
        auditEntries.push({
          setupArea: "Salary Advance Access",
          actionTaken: "update",
          field: `${selectedItem.description} - ${field.label}`,
          oldValue: oldValue,
          newValue: newValue,
          dateSaved: new Date(),
          savedById: user.id
        });
      }
    });

    const res = await updateAccess(selectedItem.id, payload, auditEntries);
    if (res.success) setIsModalOpen(false);
  };

  return (
    <div className='p-4 space-y-4 relative'>
      <div className="flex justify-between items-center">
        <SearchBar handleFilter={handleSearch} />
      </div>

      <SalaryAdvanceAccessTable
        data={data}
        onEdit={handleEdit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <SalaryAdvanceAccessAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
      />
    </div>
  );
};

export default SalaryAdvanceAccessModule;